import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaUserTie } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // In a real app, send to backend
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', message: '' });
    }, 3000);
  };

  return (
    <section id="contact" className="contact">
      <h2 className="section-title">Get In <span className="highlight">Touch</span></h2>
      <div className="contact-container">
        <form onSubmit={handleSubmit} className="contact-form">
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Tell us about your requirements..."
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit" className="btn btn-primary btn-full">
            {submitted ? '✅ Message Sent!' : 'Send Message'}
          </button>
        </form>
        <div className="contact-info">
          <h3>Contact Information</h3>
          <p><FaEnvelope /> info@taxave.in</p>
          <p><FaPhone /> +91 9332571525</p>
          <p><FaMapMarkerAlt /> India</p>
          <div className="contact-powered">
            <FaUserTie /> <span>Powered by Mr. Jana</span>
          </div>
          <div className="contact-hours">
            <h4>Business Hours</h4>
            <p>Mon - Fri: 9:00 AM - 6:00 PM</p>
            <p>Sat: 10:00 AM - 2:00 PM</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;